import React from 'react';

/**
 * Container component to maintain consistent width and padding
 * across the site.
 * 
 * @param {Object} props - Component props
 * @param {ReactNode} props.children - Child elements
 * @param {string} props.className - Additional CSS classes
 * @param {boolean} props.fluid - Whether to use max width or not
 * @param {string} props.as - HTML element to render as
 * @param {Object} props.rest - Any additional props
 */
const Container = ({ 
  children, 
  className = '', 
  fluid = false,
  as: Component = 'div',
  ...rest 
}) => {
  return (
    <Component
      className={`mx-auto px-4 sm:px-6 md:px-8 ${fluid ? 'w-full' : 'max-w-7xl'} ${className}`}
      {...rest}
    >
      {children}
    </Component>
  );
};

export default Container;